import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import ProductShelf from '../homepage/ProductShelf';

// One shelf of catalogue tiles under the product info: `products` (product
// rows) or `items` (mixed `{ kind: 'product' | 'card', data }`, the api's
// bought-together shape). Defaults to the similar-products title and anchor.
export default function ProductRelated({ products = [], items, title, id = 'product-related', trackAs = null }) {
  const { t } = useTranslation('product');
  const list = items || products.map(data => ({ kind: 'product', data }));
  if (!list.length) return null;

  return <div id={id} className="mt-12 scroll-mt-24 pt-4">
    <ProductShelf section={{ name: title || t('related.title'), items: list }} trackAs={trackAs} />
  </div>;
}
